import { createSelector } from 'reselect';
import HandlerMailRegistrationDeviceDeliveryCarrierPerformanceColumns from '../../containers/HandlerMailRegistrationDeviceDeliveryCarrierPerformanceColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  // eslint-disable-next-line max-len
  .reporting.HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE.isLoading;

export const getData =
  ReportDefinitions.HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE.getDataFunction();

export const getColumns = createSelector(
  getData,
  state => state.reporting.HANDLER_MAIL_REGISTRATION_DEVICE_DELIVERY_CARRIER_PERFORMANCE.requestParams,
  HandlerMailRegistrationDeviceDeliveryCarrierPerformanceColumns,
);
